<template>
  <div class="py-3">
    <page-title title="Admin Dashboard" />
    <hr />
    <b-card-group v-if="stats">
      <b-card class="text-center mb-3">
        <div class="kpi-value">{{stats.totalSubscriptions}}</div>
        <div class="kpi-label">Total Subscriptions</div>
      </b-card>
      <b-card class="text-center mb-3">
        <div class="kpi-value">{{stats.totalClients}}</div>
        <div class="kpi-label">Total Clients</div>
      </b-card>
      <b-card class="text-center mb-3">
        <div class="kpi-value">{{stats.newSubscriptions}}</div>
        <div class="kpi-label">New Subscriptions</div>
        <div class="kpi-small">in the past 7 days</div>
      </b-card>
    </b-card-group>
    <b-card-group v-if="stats">
      <b-card class="text-center mb-3">
        <div class="kpi-value">{{totalCompletionRate}}</div>
        <div class="kpi-label">Total Completion Rate</div>
        <div>{{ stats.totalSentSurveys }} surveys sent</div>
        <div>{{ stats.totalCompletedSurveys }} surveys completed</div>
      </b-card>
      <b-card class="text-center mb-3">
        <div class="kpi-value">{{lastMonthCompletionRate}}</div>
        <div class="kpi-label">Last Month Completion Rate</div>
        <div>{{ stats.lastMonthSentSurveys }} surveys sent</div>
        <div>{{ stats.lastMonthCompletedSurveys }} surveys completed</div>
      </b-card>
    </b-card-group>
    <b-card-group>
      <b-card class="mb-3">
        <h4>Reports</h4>
        <ul>
          <li><b-link @click="downloadExport('usageByUser')">Usage by User</b-link></li>
          <li><b-link @click="downloadExport('enterpriseSubscriptionUsersSummary')">Enterprise Subscription Users Summary</b-link></li>
          <li><b-link @click="downloadExport('enterpriseSubscriptionUsers')">Enterprise Subscription Users</b-link></li>
          <li><b-link @click="downloadExport('clientCompletionByPage')">Client Completion by Page</b-link></li>
          <li><b-link @click="downloadExport('activityByMonth')">Surveys Created, Started, Completed by Month</b-link></li>
        </ul>
      </b-card>
    </b-card-group>
    <!-- <b-card-group>
      <b-card class="mb-3">
        <subscriptions-chart :chart-data="testData" :options="testOptions"></subscriptions-chart>
      </b-card>
    </b-card-group> -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'AdminDashboard',
  props: {
  },
  data () {
    return {
      stats: null,
      testOptions: {
        legend: {

        }
      },
      testData: {
        labels: ['Jan. 1', 'Feb. 1', 'Mar. 1'],
        datasets: [
          {
            label: 'Subscriptions',
            data: [4, 12]
          },
          {
            label: 'Clients',
            data: [6, 11]
          }
        ]
      }
    }
  },
  computed: {
    totalCompletionRate: function () {
      if (!this.stats)
        return '';
      
      return (this.stats.totalCompletedSurveys / this.stats.totalSentSurveys * 100).toFixed(1) + '%';
    },
    lastMonthCompletionRate: function () {
      if (!this.stats)
        return '';
      
      return (this.stats.lastMonthCompletedSurveys / this.stats.lastMonthSentSurveys * 100).toFixed(1) + '%';
    },
  },
  methods: {
    loadStats: function () {
      axios({
        url: '/api/stats/adminDashboard',
        method: 'GET'
      }).then((response) => {
        this.stats = response.data;
      });
    },
    downloadExport: function (name) {
      axios({
        url: '/api/account/temporaryAccessToken',
        method: 'GET'
      }).then((response) => {
        window.open('/api/stats/export?temporaryAccessToken=' + response.data.token + '&name=' + name, '_blank');
      });
    },

  },
  created() {
    this.loadStats();
  }
}
</script>